import api from 'api'

export const createProject = async (payload) => {
  const { data } = await api.post('/project', payload)

  return data
}
